<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<!-- Loading Overlay for Modal Data -->
				<div v-if="loadModalData" class="loading-overlay">
					<div class="loading-spinner">
						<div class="spinner-border text-primary" role="status">
							<span class="visually-hidden">Loading ...</span>
						</div>
						<p class="mt-3">Loading Data ...</p>
					</div>
				</div>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-handshake"></i>
								Tour Register&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-handshake"
												></i
												>&nbsp;&nbsp;Reservation&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">&nbsp;&nbsp;Tour Register&nbsp;&nbsp;</li>
								</ol>
							</div>

							<div class="page-title-right font-size-13 d-none">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="#" @click.prevent="openModal('select')">
											<font-awesome-icon
												icon="fa-solid fa-mouse-pointer" />&nbsp;
											<span>Budget:&nbsp;&nbsp;</span
											><span class="text-blue-custom"></span
										></a>
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.registeredTours">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Registered Tours
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark p-2">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 d-flex justify-content-end gap-1"
													style="font-family: HeaderCustomFont"
												>
													<button
														class="btn text-none bg-info float-sm-right text-white rounded-0"
														@click="openModal('preview')"
													>
														<i class="nav-icon fas fa-print"></i
														>&nbsp;&nbsp;Tour Itinerary
													</button>
													<button
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('tour')"
														:disabled="!currentRoute"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Register Tour
													</button>
												</div>
											</div>
											<!-- v-if="selectedTour !== null" -->
											<div class="row col-sm-12 mt-2">
												<div class="p-1">
													<v-text-field
														v-model="searchTours"
														label="Search Registered Tours"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class=""
													></v-text-field>
													<v-data-table
														v-model:items-per-page="toursPerPage"
														:headers="toursHeaders"
														:items="toursComputed"
														:search="searchTours"
														item-value="id"
														density="compact"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<!-- :class="{ 'selected-row': item.id == selectedTour.id, }" -->
														<template v-slot:body="{ items }">
															<tr v-if="selectedTour" :class="'selected-row'">
																<td class="align-middle">
																	<font-awesome-icon icon="fas fa-thumbtack" />
																</td>
																<td class="align-middle">
																	<v-chip
																		class="text-white"
																		:style="{
																			backgroundColor: getStatusColor(
																				selectedTour.status
																			),
																		}"
																		small
																		rounded="sm"
																	>
																		{{ selectedTour.status }}</v-chip
																	>
																</td>
																<td>
																	{{ selectedTour.agent_name }}
																</td>
																<td class="text-bold d-none">
																	{{ selectedTour.reference_number }}
																</td>
																<td>{{ selectedTour.client }}</td>
																<!-- <td>{{ item.country }}</td> -->
																<td>
																	{{ longDate(selectedTour.from) }} -
																	{{ longDate(selectedTour.to) }}
																</td>
																<td>{{ selectedTour.pax }}</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="
																					manageTours(selectedTour, 'edit')
																				"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="
																					manageTours(selectedTour, 'delete')
																				"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
															<tr>
																<td></td>
																<td></td>
																<td></td>
																<td></td>
																<td></td>
																<td></td>
																<td></td>
															</tr>
															<!-- :class="{ 'selected-row': selectedTour && item.tour_id === selectedTour.tour_id, }" -->
															<tr
																href="#"
																@click.prevent=""
																@click="selectTour(item)"
																class="align-top clickable-row"
																v-for="(item, index) in items"
																:key="item.tour_id"
																:class="{
																	'd-none':
																		selectedTour &&
																		item.tour_id === selectedTour.tour_id,
																}"
															>
																<td class="align-middle">
																	{{ item.index + 1 }}
																</td>
																<td class="align-middle">
																	<v-chip
																		class="text-white"
																		:style="{
																			backgroundColor: getStatusColor(
																				item.status
																			),
																		}"
																		:class="{
																			'bg-info':
																				selectedTour &&
																				item.tour_id === selectedTour.tour_id,
																		}"
																		small
																		rounded="sm"
																	>
																		{{ item.status }}
																	</v-chip>
																</td>
																<td>
																	{{ item.agent_name }}
																</td>
																<td class="text-bold d-none">
																	{{ item.reference_number }}
																</td>
																<td>{{ item.client }}</td>
																<!-- <td>{{ item.country }}</td> -->
																<td class="d-none">{{ item.from }}</td>
																<td class="d-none">{{ item.to }}</td>
																<td>
																	{{ longDate(item.from) }} - <br />
																	{{ longDate(item.to) }}
																</td>
																<td>{{ item.pax }}</td>
																<!-- <td>{{ item.tracking }}</td> -->
																<!-- <td>{{ item.permit }}</td> -->
																<td class="d-none">
																	<v-icon large @click="deleteRecord(item)">
																		mdi-access-point-remove
																	</v-icon>

																	<v-icon large @click="editRecord(item)">
																		mdi-pencil
																	</v-icon>
																</td>

																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageTours(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageTours(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>

														<!-- Expandable Rows -->
														<!-- <template v-slot:expanded-row="{ item }"> <tr> <td colspan="6"> <v-container> <v-row class="bg-grey-lighten-4 pa-2"> <v-col cols="4" ><strong>Travel Dates</strong></v-col > <v-col cols="8" >{{ item.from }} - {{ item.to }}</v-col > </v-row> </v-container> </td> </tr> </template> -->
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
				<!--      
				        -->
				<div class="row card-body mt-0 p-4 d-none" v-if="selectedTour !== null">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.tourSummary">
								<v-expansion-panel disabled>
									<v-expansion-panel-title
										density="compact"
										bg-color="#029602"
										class="custom-header rounded-0"
										style="font-family: HeaderCustomFont"
									>
										Selected Tour
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body text-dark">
											<div class="row col-xl-12 table-responsive p-1">
												<table
													class="table-sm table-striped rounded-0 table-wrap"
												>
													<thead>
														<tr>
															<th>#</th>
															<th>Status</th>
															<th>Agent Name</th>
															<th>Reference</th>
															<th>Client</th>
															<th>Dates</th>
															<th>Pax</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td class="align-middle">
																{{ selectedTour.index + 1 }}
															</td>
															<td class="align-middle">
																<v-chip
																	class="text-white"
																	:style="{
																		backgroundColor: getStatusColor(
																			selectedTour.status
																		),
																	}"
																	small
																	rounded="sm"
																>
																	{{ selectedTour.status }}</v-chip
																>
															</td>
															<td>
																{{ selectedTour.agent_name }}
															</td>
															<td class="text-bold">
																{{ selectedTour.reference_number }}
															</td>
															<td>{{ selectedTour.client }}</td>
															<!-- <td>{{ item.country }}</td> -->
															<td>
																{{ selectedTour.from }} -
																{{ selectedTour.to }}
															</td>
															<td>{{ selectedTour.pax }}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.tourActivities">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Tour Itinerary
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('itinerary')"
														:disabled="!currentRoute"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Itinerary
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchItinerary"
														label="Search Tour Itinerary"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="itineraryPerPage"
														:headers="itineraryHeaders"
														:items="itineraryComputed"
														:search="searchItinerary"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<template v-slot:body="{ items }">
															<tr
																class="align-top"
																v-for="(item, index) in items"
																:key="item.id"
															>
																<td>{{ item.index + 1 }}</td>
																<td>
																	{{ "Day " + item.day_number }}
																</td>

																<!-- <td> {{ item.itinerary ? item.itinerary.name : null }} </td> 
																<td> {{ item.iitem ? item.iitem.name : null }} </td> -->
																<td v-if="item.park !== null">
																	{{ capitalizeWords(item.park.name) }}
																</td>

																<td v-else>
																	{{ capitalizeWords("No Park option") }}
																</td>
																<td>
																	{{ sentenceCase(item.itinerary_title) }}
																</td>
																<td v-if="item.lodge !== null">
																	{{ capitalizeWords(item.lodge.name) }}
																</td>

																<td v-else>
																	{{
																		capitalizeWords("No accomodation option")
																	}}
																</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageItinerary(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageItinerary(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				class="d-none"
																				@click="selectItinerary(item)"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Activities</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.excludeInclude">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Includes/Excludes
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<button
														v-if="this.selectedTour"
														@click="openModal('includes', 'insert')"
														:disabled="!currentRoute"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0 d-none"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Include/Exclude
													</button>
												</div>
											</div>

											<!-- v-if="this.selectedTour && this.includes.length > 0" -->
											<div class="row col-sm-12 mt-2">
												<div class="form-group">
													<label class="form-label font-size-16 mb-3"
														>Included Services:</label
													>
													<vue-editor
														v-if="editorReady"
														v-model="tourIncludes.include_detail"
														:key="'editor-' + tourIncludes.tour_id"
														:editorToolbar="customToolbar"
														placeholder="Enter Include Details ..."
														style="min-height: 300px"
													></vue-editor>
													<div v-else class="text-center p-5">
														<div
															class="spinner-border text-primary"
															role="status"
														>
															<span class="sr-only">Loading editor...</span>
														</div>
													</div>
												</div>
												<div class="table-responsive p-1 d-none">
													<v-data-table
														v-model:items-per-page="includePerPage"
														:headers="includeHeaders"
														:items="includesComputed"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<template v-slot:body="{ items }">
															<tr
																class="align-top"
																v-for="(item, index) in items"
																:key="item.id"
															>
																<td>{{ item.index + 1 }}</td>
																<td>
																	{{
																		item.include
																			? capitalizeWords(item.include_type) +
																			  ": " +
																			  item.include.detail
																			: null
																	}}
																</td>
																<td>
																	{{
																		item.include_detail
																			? item.include_detail
																			: null
																	}}
																</td>

																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageIncludes(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageIncludes(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
											<div class="row col-sm-12">
												<div class="form-group">
													<label class="form-label font-size-16 mb-3"
														>Excluded Services:</label
													>
													<vue-editor
														v-if="editorReady"
														v-model="tourIncludes.exclude_detail"
														:key="'editor-' + tourIncludes.tour_id"
														:editorToolbar="customToolbar"
														placeholder="Enter Exclude Detail ..."
														style="min-height: 300px"
													></vue-editor>
													<div v-else class="text-center p-5">
														<div
															class="spinner-border text-primary"
															role="status"
														>
															<span class="sr-only">Loading editor...</span>
														</div>
													</div>
													<div class="justify-content-start mt-2 custom-font">
														<button
															type="button"
															class="btn bg-green-custom text-white w-10 m-2"
															@click="manageIncludes(tourIncludes, 'update')"
															:disabled="!currentRoute"
														>
															Save Includes/Excludes
														</button>
													</div>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- v-model="openPanels.tourFeedback" -->
							<v-expansion-panels v-model="openPanels.tourFeedback">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Tour Feedback
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('feedback')"
														:disabled="!currentRoute"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Save
														Feedback
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-data-table
														v-model:items-per-page="feedbackPerPage"
														:headers="feedbackHeaders"
														:items="feedbackComputed"
														:search="searchFeedback"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<template v-slot:body="{ items }">
															<tr
																class="align-top"
																v-for="(item, index) in items"
																:key="item.id"
															>
																<td>{{ item.index + 1 }}</td>
																<td>
																	{{ item.tourist ? item.tourist.name : null }}
																</td>
																<td>
																	{{ item.feedback_rate }}
																</td>
																<td>
																	{{ item.content }}
																</td>

																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageFeedback(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageFeedback(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
												<div class="row d-none">
													<div class="col-md-12 d-flex flex-column">
														<label for="includes" class="form-label d-none"
															>Tour Feedback</label
														>
														<span
															v-if="tourRegister.errors.has('includes')"
															class="text-danger text-lowercase"
														>
															{{ tourRegister.errors.get("includes") }}
														</span>
													</div>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.tourLog">
								<v-expansion-panel>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Tour Log
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														class="d-none btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('log')"
														:disabled="!currentRoute"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Log
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchLog"
														label="Search Tour Guests"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="logPerPage"
														:headers="logHeaders"
														:items="logs"
														:search="searchLog"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr
																v-for="(item, index) in items"
																:key="item.name"
															>
																<td>{{ index + 1 }}</td>
																<td>{{ item.action }}</td>
																<td>{{ item.date }}</td>
																<td>{{ item.info }}</td>
																<td>{{ item.user }}</td>
																<td class="d-none">
																	<v-icon large @click="deleteRecord(item)">
																		mdi-access-point-remove
																	</v-icon>

																	<v-icon large @click="editRecord(item)">
																		mdi-pencil
																	</v-icon>

																	<v-icon large @click="displayReport(item)">
																		mdi-file-document
																	</v-icon>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
			</div>
			<!-- template -->
			<v-dialog max-width="1250px" persistent>
				<v-card>
					<v-card-title class="d-flex justify-space-between align-center">
						<v-icon @click="closeModal('tour')">mdi-close</v-icon>
					</v-card-title>
					<!-- Dialog Content -->
					<v-card-text> </v-card-text>

					<!-- Footer with Action Buttons -->
					<v-card-actions>
						<v-spacer> </v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!-- Forms -->
			<v-dialog v-model="tourModal" max-width="1250px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageTours(this.tourRegister, 'update')
								: manageTours(this.tourRegister, 'insert')
						"
					>
						<!-- Custom Header -->
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<!-- <slot name="header">default header</slot> -->
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon
											icon="fas fa-handshake"
										/>&nbsp;&nbsp;Register Tour
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('tour')">mdi-close</v-icon>
						</v-card-title>

						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mb-2">
										<div class="col-md-12">
											<div class="">
												<blockquote
													class="blockquote font-size-13 mb-0 text-dark"
												>
													<p>
														Admin and Leader percentages should not be more than
														100%. Speke Account is the account out of which this
														tour should be processed, if not sure ask the
														manager
													</p>
													<footer class="blockquote-footer">
														<cite title="Source Title">Usage Notes</cite>
													</footer>
												</blockquote>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-8 required">
											<label for="tour_title" class="form-label">
												<span
													v-if="tourRegister.errors.has('tour_title')"
													class="text-danger text-lowercase"
												>
													{{ tourRegister.errors.get("tour_title") }} </span
												><span v-else>Tour/Safari Title</span>
											</label>

											<v-text-field
												density="compact"
												rounded="0"
												id="tour_title"
												v-model="tourRegister.tour_title"
												placeholder="Enter Tour Title"
												variant="outlined"
												:class="{
													'required-error':
														tourRegister.errors.has('tour_title'),
												}"
												@input="
													() =>
														console.log(tourRegister.errors.has('tour_title'))
												"
											></v-text-field>
										</div>
										<div class="col-md-4">
											<div class="mb-3 required">
												<label for="agent_id" class="form-label"
													><span
														v-if="tourRegister.errors.has('agent_id')"
														class="text-danger text-lowercase"
													>
														{{ tourRegister.errors.get("agent_id") }} </span
													><span v-else>Agent</span></label
												>

												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Select Agent"
													:items="this.infiniteAgents.data"
													v-model="tourRegister.agent_id"
													@input="
														selectItem('tourRegister', 'agent_id', $event)
													"
													item-title="name"
													item-value="id"
													:class="{
														'is-invalid': tourRegister.errors.has('agent_id'),
													}"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-4 d-none">
											<label for="internal_title" class="form-label">
												Internal Title
											</label>
											<span
												v-if="tourRegister.errors.has('internal_title')"
												class="text-danger text-lowercase"
											>
												{{ tourRegister.errors.get("internal_title") }}
											</span>
											<v-text-field
												density="compact"
												rounded="0"
												id="internal_title"
												v-model="tourRegister.internal_title"
												placeholder="Enter Internal Title"
												variant="outlined"
											></v-text-field>
										</div>

										<div class="col-md-3 required">
											<label for="client" class="form-label">
												<span
													v-if="tourRegister.errors.has('client')"
													class="text-danger text-lowercase"
												>
													{{ tourRegister.errors.get("client") }} </span
												><span v-else>Client Name</span>
											</label>

											<v-text-field
												density="compact"
												rounded="0"
												id="client"
												v-model="tourRegister.client"
												placeholder="Client Name"
												variant="outlined"
											></v-text-field>
										</div>

										<!-- <div class="row mt-1"></div> -->
										<div class="col-md-3 required" v-if="!editMode">
											<label for="speke_account" class="form-label"
												><span
													v-if="tourRegister.errors.has('speke_account')"
													class="text-danger text-lowercase"
												>
													{{ tourRegister.errors.get("speke_account") }} </span
												><span v-else>Speke Account</span></label
											>
											<v-select
												density="compact"
												variant="outlined"
												rounded="0"
												placeholder="Select Speke Account"
												:items="spekeAccounts"
												item-title="label"
												item-value="value"
												v-model="tourRegister.speke_account"
												id="speke_account"
											>
											</v-select>
										</div>

										<div
											class="col-md-3"
											v-if="
												Object.keys(this.itineraries).length !== 0 && editMode
											"
										>
											<div class="">
												<label for="status" class="form-label"
													>Tour Status</label
												><span
													v-if="tourRegister.errors.has('status')"
													class="text-danger text-lowercase"
												>
													{{ tourRegister.errors.get("status") }}
												</span>
												<v-select
													density="compact"
													variant="outlined"
													rounded="0"
													:items="['tentative', 'confirmed', 'cancelled']"
													v-model="tourRegister.status"
													id="status"
												>
												</v-select>
											</div>
										</div>
										<div class="col-md-2">
											<div class="required">
												<label for="from" class="form-label">
													<span
														v-if="tourRegister.errors.has('from')"
														class="text-danger text-lowercase"
													>
														{{ tourRegister.errors.get("from") }} </span
													><span v-else> Start Date </span>
												</label>

												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Start Date"
													v-model="tourRegister.from"
													id="from"
													class="mb-0"
													@input="tourRegister.to = tourRegister.from"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2">
											<div class="mb-3 required">
												<label for="days" class="form-label"
													><span
														v-if="tourRegister.errors.has('days')"
														class="text-danger text-lowercase"
													>
														{{ tourRegister.errors.get("days") }} </span
													><span v-else>Tour Days</span></label
												>

												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Tour Days"
													v-model="tourRegister.days"
													id="days"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2 d-none">
											<div class="mb-3 required">
												<label for="to" class="form-label"
													><span
														v-if="tourRegister.errors.has('to')"
														class="text-danger text-lowercase"
													>
														{{ tourRegister.errors.get("to") }} </span
													><span v-else> End Date </span></label
												>

												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Start Date"
													v-model="tourRegister.to"
													id="to"
												></v-text-field>
											</div>
										</div>
									</div>

									<div class="row mt-1">
										<div class="col-md-4 d-none">
											<div class="mb-0">
												<label for="country" class="form-label"
													><span
														v-if="tourRegister.errors.has('reference_number')"
														class="text-danger text-lowercase"
													>
														{{
															tourRegister.errors.get("reference_number")
														}} </span
													><span v-else>Country</span></label
												>

												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													placeholder="Select Country"
													:items="this.infiniteCountries.data"
													v-model="tourRegister.country"
													item-title="name"
													item-value="id"
												>
												</v-autocomplete>
											</div>
										</div>

										<div class="col-md-2">
											<div class="mb-3 required">
												<label for="pax" class="form-label"
													><span
														v-if="tourRegister.errors.has('pax')"
														class="text-danger text-lowercase"
													>
														{{ tourRegister.errors.get("pax") }} </span
													><span v-else>Pax</span></label
												>

												<v-text-field
													density="compact"
													rounded="0"
													id="pax"
													v-model="tourRegister.pax"
													placeholder="Guest Number"
													variant="outlined"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2">
											<div class="mb-3">
												<label for="pax" class="form-label"
													><span
														v-if="tourRegister.errors.has('admin_percentage')"
														class="text-danger text-lowercase"
													>
														{{
															tourRegister.errors.get("admin_percentage")
														}} </span
													><span v-else>Admin %</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="admin_percentage"
													v-model="tourRegister.admin_percentage"
													placeholder="Admin Percentage"
													variant="outlined"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2">
											<div class="mb-3">
												<label for="pax" class="form-label"
													><span
														v-if="
															tourRegister.errors.has('tour_leader_percentage')
														"
														class="text-danger text-lowercase"
													>
														{{
															tourRegister.errors.get("tour_leader_percentage")
														}} </span
													><span v-else>Leader %</span></label
												>
												<v-text-field
													density="compact"
													rounded="0"
													id="tour_leader_percentage"
													v-model="tourRegister.tour_leader_percentage"
													placeholder="Leader Percentage"
													variant="outlined"
												></v-text-field>
											</div>
										</div>

										<div class="col-md-2 required">
											<label for="guide_language" class="form-label"
												><span
													v-if="tourRegister.errors.has('guide_language')"
													class="text-danger text-lowercase"
												>
													{{ tourRegister.errors.get("guide_language") }} </span
												><span v-else>Guide Language</span></label
											>
											<v-select
												density="compact"
												variant="outlined"
												rounded="0"
												placeholder="Select Guide Language"
												:items="this.guideLanguages.data"
												item-title="language"
												item-value="language"
												v-model="tourRegister.guide_language"
												id="guide_language"
											>
											</v-select>
										</div>
										<div class="col-md-3" v-if="editMode">
											<label for="reference_number" class="form-label"
												><span
													v-if="tourRegister.errors.has('reference_number')"
													class="text-danger text-lowercase"
												>
													{{
														tourRegister.errors.get("reference_number")
													}} </span
												><span v-else>Reference Number</span></label
											>

											<v-text-field
												density="compact"
												rounded="0"
												disabled
												id="reference_number"
												v-model="tourRegister.reference_number"
												placeholder="Reference Number"
												variant="outlined"
											></v-text-field>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12">
											<label for="additional_information" class="form-label"
												>Description</label
											>
											<span
												v-if="tourRegister.errors.has('additional_information')"
												class="text-danger text-lowercase"
											>
												{{ tourRegister.errors.get("additional_information") }}
											</span>
											<v-textarea
												density="compact"
												variant="outlined"
												rounded="0"
												rows="3"
												placeholder="Tour Additional Information"
												v-model="tourRegister.additional_information"
												id="additional_information"
											></v-textarea>
										</div>
									</div>
									<!-- </div> -->
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
										:disabled="!currentRoute"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Tour
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('tour')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="itineraryModal" max-width="1250px" persistent>
				<v-card
					><form
						@submit.prevent="
							editMode
								? manageItinerary(this.tourItinerary, 'update')
								: manageItinerary(this.tourItinerary, 'insert')
						"
					>
						<!-- style=" position: sticky; top: 0; z-index: 10; background-color: white; " -->
						<v-card-title
							class="dialog-title d-flex justify-space-between align-center"
							><div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Itinerary
								</h5>
							</div>
							<v-icon @click="closeModal('itinerary')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<!-- style="padding-bottom: 0px; overflow-y: auto; height: 600px" -->
						<v-card-text class="dialog-text">
							<div class="modal-body p-4">
								<div class="modal-body p-4">
									<div
										id="preloader d-none"
										class="col-sm-2 p-5"
										v-if="this.processing"
									>
										<div id="status">
											<div class="spinner-chase text-start">
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
											</div>
										</div>
									</div>
									<div class="text-start">
										<div class="row">
											<div class="col-md-12">
												<div class="mb-3 required">
													<label for="agent_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('itinerary_item')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("itinerary_item")
															}} </span
														><span v-else>Itinerary Item</span></label
													>

													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Itinerary Item"
														:items="this.infiniteItems.data"
														v-model="tourItinerary.itinerary_item"
														@update:modelValue="selectItem($event)"
														:item-title="(item) => capitalizeWords(item.title)"
														item-value="id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-7 required">
												<div class="">
													<label for="title" class="form-label"
														><span
															v-if="tourItinerary.errors.has('itinerary_title')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("itinerary_title")
															}} </span
														><span v-else>Activity Title</span></label
													>
													<v-text-field
														density="compact"
														variant="outlined"
														rounded="0"
														clearable
														placeholder="Activity Title"
														v-model="tourItinerary.itinerary_title"
														id="title"
													></v-text-field>
												</div>
											</div>
											<div class="col-md-2 required">
												<div class="">
													<label for="day_number" class="form-label"
														><span
															v-if="tourItinerary.errors.has('day_number')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("day_number")
															}} </span
														><span v-else>Day Number</span></label
													>

													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Day Number"
														:items="this.tourDays.data"
														v-model="tourItinerary.day_number"
														item-title="Title"
														item-value="Day"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-3">
												<div class="mb-3">
													<label for="district_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('district_id')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("district_id")
															}} </span
														><span v-else>Destination</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select District"
														:items="this.infiniteDistricts.data"
														v-model="tourItinerary.district_id"
														:item-title="
															(item) => capitalizeWords(item.district_name)
														"
														item-value="id"
														id="district_id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row">
											<div
												class="col-md-4 required"
												v-if="this.selectedTour == null"
											>
												<div class="">
													<label for="tour_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('tour_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("tour_id") }} </span
														><span v-else>Select Tour</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														placeholder="Select Itinerary Tour"
														:items="this.tours.data"
														v-model="tourItinerary.tour_id"
														item-value="id"
														item-title="reference_number"
														id="tour_id"
													>
													</v-autocomplete>
												</div>
											</div>

											<div class="col-md-2 d-none">
												<div class="">
													<label for="activity_date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('activity_date')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("activity_date")
															}} </span
														><span v-else>Date</span></label
													>
													<v-text-field
														density="compact"
														variant="outlined"
														rounded="0"
														type="date"
														clearable
														placeholder="Date"
														v-model="tourItinerary.activity_date"
														id="activity_date"
													></v-text-field>
												</div>
											</div>

											<div class="col-md-6">
												<div class="">
													<label for="date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('transit_time')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("transit_time")
															}} </span
														><span v-else>Transit Time</span></label
													>
													<div class="d-flex gap-1">
														<v-text-field
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Time"
															v-model="tourItinerary.transit_time"
															id="transit_time"
															style="flex: 1"
														></v-text-field>
														<v-select
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Unit"
															:items="['Mins', 'Hours', 'Days', 'Weeks']"
															v-model="tourItinerary.transit_unit"
															id="transit_unit"
															style="flex: 1"
														></v-select>
														<v-select
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="How"
															:items="[
																'Driving',
																'Walking',
																'Hiking',
																'Riding',
																'Sailing',
															]"
															v-model="tourItinerary.transit_method"
															id="transit_method"
															style="flex: 1"
														></v-select>
													</div>
												</div>
											</div>
											<div class="col-md-4">
												<div class="">
													<label for="date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('distance')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("distance") }} </span
														><span v-else>Distance</span></label
													>
													<div class="d-flex gap-1">
														<v-text-field
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Distance"
															v-model="tourItinerary.distance"
															id="distance"
															style="flex: 1"
														></v-text-field>
														<v-select
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Units"
															:items="[
																'Km',
																'Metres',
																'Miles',
																'Yards',
																'Feet',
															]"
															v-model="tourItinerary.distance_unit"
															id="distance_unit"
															style="flex: 1"
														></v-select>
													</div>
												</div>
											</div>
											<div class="col-md-2">
												<div class="">
													<label for="date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('flight_time')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("flight_time")
															}} </span
														><span v-else>Flight Time</span></label
													>
													<v-text-field
														density="compact"
														variant="outlined"
														rounded="0"
														clearable
														placeholder="Flight Time"
														v-model="tourItinerary.flight_time"
														id="flight_time"
													></v-text-field>
												</div>
											</div>

											<div class="col-md-3 d-none">
												<div class="mb-3">
													<label for="town_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('town_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("town_id") }} </span
														><span v-else>Destination Town </span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Town"
														:items="filteredTowns"
														v-model="tourItinerary.town_id"
														:item-title="
															(item) => capitalizeWords(item.town_name)
														"
														item-value="id"
														id="town_id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-4">
												<div class="mb-3">
													<label for="park_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('park_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("park_id") }} </span
														><span v-else>National Park</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select National Park"
														:items="this.infiniteParks.data"
														v-model="tourItinerary.park_id"
														item-title="name"
														item-value="id"
														id="park_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-4">
												<div class="mb-3">
													<label for="accommodation_id" class="form-label"
														><span
															v-if="
																tourItinerary.errors.has('accommodation_id')
															"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("accommodation_id")
															}} </span
														><span v-else>Accomodation Option</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Accomodation"
														:items="this.infiniteAccomodations.data"
														v-model="tourItinerary.accommodation_id"
														item-title="name"
														item-value="id"
														id="accommodation_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div
												class="col-md-2 required"
												v-if="tourItinerary.accommodation_id"
											>
												<div class="">
													<label for="meal_plan_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('meal_plan_id')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("meal_plan_id")
															}} </span
														><span v-else>Meal Plan</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														clearable
														return-object
														placeholder="Select Plan"
														:items="this.infiniteMeals.data"
														v-model="tourItinerary.meal_plan_id"
														item-title="name"
														item-value="id"
														id="meal_plan_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div
												class="col-md-2"
												v-if="tourItinerary.accommodation_id"
											>
												<div class="mb-3">
													<label for="room_type" class="form-label"
														>Room Type</label
													>
													<span
														v-if="tourItinerary.errors.has('room_type')"
														class="text-danger text-lowercase"
													>
														{{ tourItinerary.errors.get("room_type") }}
													</span>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Room Type"
														:items="this.infiniteRooms.data"
														v-model="tourItinerary.room_type"
														item-title="name"
														item-value="id"
														id="room_type"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<div class="mb-3">
													<label for="boat_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('boat_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("boat_id") }} </span
														><span v-else>Boat Ride</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Boat Ride"
														:items="this.infiniteBoats.data"
														v-model="tourItinerary.boat_id"
														item-title="name"
														item-value="id"
														id="boat_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-4">
												<div class="mb-3">
													<label for="flight_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('flight_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("flight_id") }} </span
														><span v-else>Flight Option</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Required Flight"
														:items="this.infiniteFlights.data"
														v-model="tourItinerary.flight_id"
														item-title="name"
														item-value="id"
														id="flight_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-4">
												<div class="mb-3">
													<label for="vehicle_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('vehicle_id')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("vehicle_id")
															}} </span
														><span v-else>Vehicle</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Required Vehicle"
														:items="this.infiniteVehicles.data"
														v-model="tourItinerary.vehicle_id"
														item-value="id"
														item-title="vehicle_type"
														id="vehicle_id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row d-none">
											<div class="col-md-4">
												<div class="mb-3">
													<label for="accommodation_id" class="form-label"
														>Accomodation Options:</label
													>
												</div>
											</div>
										</div>
										<div class="row mt-1">
											<div class="col-md-3 d-none">
												<div class="mb-3">
													<label for="upper_lodge" class="form-label"
														>Upper Medium Option</label
													><span
														v-if="tourItinerary.errors.has('upper_lodge')"
														class="text-danger text-lowercase"
													>
														{{ tourItinerary.errors.get("upper_lodge") }}
													</span>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Accomodation"
														:items="this.infiniteAccomodations.data"
														v-model="tourItinerary.upper_lodge"
														@update:modelValue="upperSelection()"
														item-title="name"
														item-value="id"
														id="upper_lodge"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-3 d-none">
												<div class="mb-3">
													<label for="high_lodge" class="form-label"
														>High Option</label
													><span
														v-if="tourItinerary.errors.has('high_lodge')"
														class="text-danger text-lowercase"
													>
														{{ tourItinerary.errors.get("high_lodge") }}
													</span>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Accomodation"
														:items="this.infiniteAccomodations.data"
														v-model="tourItinerary.high_lodge"
														@update:modelValue="highSelection()"
														item-title="name"
														item-value="id"
														id="high_lodge"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-3 d-none">
												<div class="mb-3">
													<label for="luxury_lodge" class="form-label"
														>Luxury Option</label
													><span
														v-if="tourItinerary.errors.has('luxury_lodge')"
														class="text-danger text-lowercase"
													>
														{{ tourItinerary.errors.get("luxury_lodge") }}
													</span>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Accomodation"
														:items="this.infiniteAccomodations.data"
														v-model="tourItinerary.luxury_lodge"
														@update:modelValue="luxurySelection()"
														item-title="name"
														item-value="id"
														id="luxury_lodge"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row mt-1">
											<div class="col-md-12">
												<label for="additional_information" class="form-label"
													>Additional Information</label
												>
												<span
													v-if="
														tourItinerary.errors.has('additional_information')
													"
													class="text-danger text-lowercase"
												>
													{{
														tourItinerary.errors.get("additional_information")
													}}
												</span>
												<v-textarea
													density="compact"
													variant="outlined"
													rounded="0"
													rows="5"
													placeholder="Itinerary Additional Information"
													v-model="tourItinerary.additional_information"
													id="additional_information"
												></v-textarea>
											</div>
										</div>
									</div>
								</div>
								<!-- end of modal body -->
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
										:disabled="!currentRoute"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Itinerary
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('itinerary')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="feedbackModal"
				max-width="1250px"
				persistent
				scroll-strategy="none"
			>
				<v-card
					><form
						@submit.prevent="
							editMode
								? manageFeedback(this.tourFeedback, 'update')
								: manageFeedback(this.tourFeedback, 'insert')
						"
					>
						<!-- style=" position: sticky; top: 0; z-index: 10; background-color: white; " -->
						<v-card-title
							class="dialog-title d-flex justify-space-between align-center"
							><div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Feedback
								</h5>
							</div>
							<!-- <v-icon @click="closeModal('itinerary')">mdi-close</v-icon> -->
						</v-card-title>
						<!-- Dialog Content -->
						<!-- style="padding-bottom: 0px; overflow-y: auto; height: 600px" -->
						<v-card-text class="dialog-text">
							<div class="modal-body p-4">
								<div class="modal-body p-4">
									<div
										id="preloader d-none"
										class="col-sm-2 p-5"
										v-if="this.processing"
									>
										<div id="status">
											<div class="spinner-chase text-start">
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
											</div>
										</div>
									</div>
									<div class="text-start">
										<div class="row mt-1">
											<div class="col-md-6">
												<div class="mb-3 required">
													<label for="tourist_id" class="form-label"
														><span
															v-if="tourFeedback.errors.has('tourist_id')"
															class="text-danger text-lowercase"
														>
															{{ tourFeedback.errors.get("tourist_id") }} </span
														><span v-else>Tourist/Guest</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Tourist"
														:items="this.infiniteTourists.data"
														v-model="tourFeedback.tourist_id"
														item-title="name"
														item-value="id"
														id="tourist_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-6">
												<div class="mb-3 required">
													<label for="feedback_rate" class="form-label"
														><span
															v-if="tourFeedback.errors.has('feedback_rate')"
															class="text-danger text-lowercase"
														>
															{{
																tourFeedback.errors.get("feedback_rate")
															}} </span
														><span v-else>Rate Our Service</span></label
													>
													<v-slider
														v-model="tourFeedback.feedback_rate"
														:max="10"
														:min="0"
														:step="1"
														thumb-label="always"
														track-color="green"
														id="feedback_rate"
													></v-slider>
												</div>
											</div>
										</div>
										<div class="row mt-1">
											<div class="col-md-12">
												<label for="content" class="form-label"
													><span
														v-if="tourFeedback.errors.has('content')"
														class="text-danger text-lowercase"
													>
														{{ tourFeedback.errors.get("content") }} </span
													><span v-else>Tourist Remarks</span></label
												>
												<v-textarea
													density="compact"
													variant="outlined"
													rounded="0"
													rows="5"
													placeholder="Tourist Remarks"
													v-model="tourFeedback.content"
													id="content"
												></v-textarea>
											</div>
										</div>
										<div class="row mt-1 d-none">
											<div class="col-md-12">
												<label for="content" class="form-label"
													>Feedback Content</label
												>
												<span
													v-if="tourFeedback.errors.has('content')"
													class="text-danger text-lowercase"
												>
													{{ tourFeedback.errors.get("content") }}
												</span>
												<mavon-editor
													v-model="tourFeedback.content"
													:subfield="false"
													:editable="true"
													defaultOpen="preview"
													language="en"
													style="height: 50px"
													class="border border-dark border-2 rounded-0"
													:toolbars="this.toolbars"
												></mavon-editor>
											</div>
										</div>
									</div>
								</div>
								<!-- end of modal body -->
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
										:disabled="!currentRoute"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Itinerary
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('feedback')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="includesModal" max-width="900px" persistent>
				<v-card
					><form
						@submit.prevent="
							editMode
								? manageIncludes(this.tourIncludes, 'update')
								: manageIncludes(this.tourIncludes, 'insert')
						"
					>
						<!-- style=" position: sticky; top: 0; z-index: 10; background-color: white; " -->
						<v-card-title
							class="dialog-title d-flex justify-space-between align-center"
							><div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Includes
								</h5>
							</div>
						</v-card-title>
						<v-card-text class="dialog-text">
							<div class="modal-body p-4">
								<div class="modal-body p-4">
									<div
										id="preloader d-none"
										class="col-sm-2 p-5"
										v-if="this.processing"
									>
										<div id="status">
											<div class="spinner-chase text-start">
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
											</div>
										</div>
									</div>
									<div class="text-start">
										<div class="row mt-1">
											<div class="col-md-8 required">
												<label for="name" class="form-label"
													><span
														v-if="tourIncludes.errors.has('include_id')"
														class="text-danger text-lowercase"
													>
														{{ tourIncludes.errors.get("include_id") }} </span
													><span v-else>Select Include/Exclude</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Include"
													:items="this.infiniteIncludes.data"
													v-model="tourIncludes.include_id"
													item-value="id"
													item-title="detail"
													id="include_id"
												>
												</v-autocomplete>
											</div>
											<div class="col-md-4 required">
												<label for="name" class="form-label"
													><span
														v-if="tourIncludes.errors.has('include_type')"
														class="text-danger text-lowercase"
													>
														{{ tourIncludes.errors.get("include_type") }} </span
													><span v-else>Select Type</span></label
												>
												<v-select
													density="compact"
													variant="outlined"
													rounded="0"
													placeholder="Select Type"
													:items="['include', 'exclude']"
													v-model="tourIncludes.include_type"
													id="include_type"
												>
												</v-select>
											</div>
										</div>
										<div class="row mt-1">
											<div class="col-md-12 required">
												<div class="">
													<label for="name" class="form-label"
														><span
															v-if="tourIncludes.errors.has('include_detail')"
															class="text-danger text-lowercase"
														>
															{{
																tourIncludes.errors.get("include_detail")
															}} </span
														><span v-else>Include Detail</span></label
													>
													<v-text-field
														density="compact"
														variant="outlined"
														rounded="0"
														clearable
														placeholder="Include Detail"
														v-model="tourIncludes.include_detail"
														id="include_detail"
													></v-text-field>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- end of modal body -->
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer mt-5"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
										:disabled="!currentRoute"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('includes')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="previewModal" max-width="1250px" persistent>
				<v-card>
					<v-card-title class="d-flex justify-space-between align-center">
						<div class="modal-header">
							<h5
								class="modal-title font-size-20 text-dark"
								style="font-family: HeaderCustomFont"
							>
								<font-awesome-icon icon="fa-solid fa-print" />&nbsp;&nbsp;Tour
								Itinerary
							</h5>
						</div>
						<v-icon @click="closeModal('preview')">mdi-close</v-icon>
					</v-card-title>

					<v-card-text class="pa-4">
						<div
							v-if="pdfLoading"
							class="d-flex justify-center align-center"
							style="height: 650px"
						>
							<div class="text-center">
								<div class="spinner-border text-primary" role="status">
									<span class="visually-hidden">Generating PDF...</span>
								</div>
								<p class="mt-3">Generating document...</p>
							</div>
						</div>
						<div v-else class="overflow-y-auto" style="height: 650px">
							<iframe
								v-if="pdfDocument !== ''"
								:src="pdfDocument"
								width="100%"
								height="650px"
								style="border: none"
							></iframe>
							<div v-else class="text-center text-muted pt-10">
								No document to display.
							</div>
						</div>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<div
							class="justify-content-start modal-footer"
							style="font-family: HeaderCustomFont"
						>
							<a
								v-if="pdfDocument !== ''"
								:href="pdfDocument"
								download="tour-itinerary.pdf"
								class="btn bg-green-custom text-white w-10 m-2"
							>
								<i class="fas fa-download"></i>&nbsp;&nbsp;Download
							</a>
							<button
								type="button"
								class="btn bg-danger square-button text-white w-10 m-2"
								@click="closeModal('preview')"
							>
								Close
							</button>
						</div>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import { useBreakpoint } from "vuetify";
import config from "../../config/settings.js";
import { Errors, Form } from "vform";
import { VueEditor } from "vue3-editor";

// import MarkdownIt from "markdown-it";
// import TurndownService from "turndown";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
	// mixins: [quillMixin],
	components: {
		VueEditor,
		// pagination,
	},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			processing: "",
			selectedTour: null,
			selectedItinerary: null,
			message: "",
			http_code: "",
			screenWidth: window.innerWidth,
			editMode: false,
			tourModal: false,
			guestModal: false,
			touristModal: false,
			accomodationModal: false,
			activityModal: false,
			itineraryModal: false,
			pricingModal: false,
			optionalModal: false,
			flightsModal: false,
			boatsModal: false,
			includesModal: false,
			editorReady: false,
			excludesModal: false,
			feedbackModal: false,
			logModal: false,
			previewModal: false,
			pdfDocument: "",
			pdfLoading: false,
			loadModalData: false,
			tourData: false,
			itineraryData: false,
			guideLanguages: [],
			infiniteAccomodations: [],
			infiniteActivity: [],
			infiniteAgents: [],
			infiniteBoats: [],
			infiniteCountries: [],
			infiniteDistricts: [],
			infiniteFlights: [],
			infiniteGenders: ["male", "female"],
			infiniteIncludes: [],
			infiniteItems: [],
			infiniteItineraryz: [],
			infiniteMeals: [],
			infiniteNationality: [],
			infiniteParks: [],
			infiniteRooms: [],
			infiniteTourists: [],
			infiniteTowns: [],
			infiniteVehicles: [],
			breakdownCosts: [],
			optionCosts: [],
			tourDays: [],
			expectedItinerary: "",
			spekeAccounts: [
				{ label: "Speke Uganda Holidays (SUH)", value: "SUH" },
				{ label: "Prestige", value: "Prestige" },
			],
			tourRegister: new Form({
				id: "",
				tour_id: "",
				additional_information: "",
				admin_percentage: "",
				agent_id: null,
				client: "",
				days: "",
				deleted_at: "",
				excludes: "",
				from: null,
				ground_quote_status: "",
				guide_language: null,
				includes: "",
				internal_title: "",
				notified_user: "",
				pax: "",
				payment_status: "",
				per_person: "",
				permit_status: "",
				priority: "",
				reference_number: "",
				safari_id: "",
				single_room_surcharge: "",
				speke_account: null,
				status: "",
				to: null,
				total: "",
				tour_leader_percentage: "",
				tour_leader_rate: "",
				tour_title: "",
				created_at: "",
				updated_at: "",
				created_by: "",
			}),
			tourIncludes: new Form({
				id: "",
				tour_id: null,
				include_id: null,
				include_detail: "",
				description: "",
				include_type: null,
				created_by: "",
				updated_by: "",
			}),
			tourExcludes: new Form({
				id: "",
				tour_id: null,
				exclude_id: null,
				exclude_detail: "",
				description: "",
				type: null,
				created_by: "",
				updated_by: "",
			}),

			tourItinerary: new Form({
				id: "",
				tour_id: null,
				accommodation_id: null,
				boat_id: null,
				flight_id: null,
				vehicle_id: null,
				park_id: null,
				district_id: null,
				town_id: null,

				activity_date: "",
				additional_information: "",
				created_by: "",
				day_number: null,
				deleted_at: "",
				destination: "",
				distance: "",
				distance_unit: null,
				flight_time: "",
				high_lodge: null,
				itinerary: "",
				itinerary_activity: "",
				itinerary_item: null,
				itinerary_title: "",
				luxury_lodge: null,
				meal_plan_id: null,
				medium_lodge: null,
				room_type: null,
				transit_time: "",
				transit_unit: null,
				transit_method: null,
				updated_by: "",
				upper_lodge: null,
			}),
			tourFeedback: new Form({
				id: "",
				tour_id: null,
				tourist_id: null,
				feedback_rate: 0,
				content: "",
				deleted_at: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
				is_deleted: "",
				deleted_by: "",
			}),
			tourLog: new Form({
				id: "",
				tour_id: "",
				user_id: "",
				action: "",
				data: "",
				created_at: "",
				created_by: "",
				updated_at: "",
				updated_by: "",
			}),
			searchQuery: "",

			// Users Table Data
			searchTours: "",
			toursPerPage: 10,
			tours: [],
			paginatedTours: [],
			tourPage: 1,
			tourSortBy: null,
			tourSortDesc: false,
			toursHeaders: [
				{ title: "#", value: "id", sortable: false },
				{ title: "Status", value: "status", sortable: true },
				{ title: "Agent", value: "agent_name", sortable: true },
				// { title: "Reference", value: "reference_number", sortable: true },
				{ title: "Client", value: "client", sortable: true },
				// { title: "Country", value: "country", sortable: true },
				{ title: "Travel Dates", value: "travel_dates", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				// { title: "Tracking", value: "tracking", sortable: true },
				// { title: "Permit", value: "permit", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],

			searchSummary: "",
			summaryPerPage: 10,
			summaries: [],
			summaryHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Status", value: "status", sortable: true },
				{ title: "Agent", value: "agent", sortable: true },
				{ title: "Client", value: "client", sortable: true },
				{ title: "Country", value: "country", sortable: true },
				{ title: "Travel", value: "travel", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				{ title: "Tracking", value: "tracking", sortable: true },
				{ title: "Permit", value: "permit", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
			],

			searchTourists: "",
			touristsPerPage: 10,
			tourists: [],
			touristsHeaders: [
				{ title: "#", value: "id", sortable: true },
				{ title: "Guest", value: "name", sortable: true },
				{ title: "Country", value: "country_id", sortable: true },
				{ title: "Gender", value: "gender", sortable: true },
				{ title: "Arrival Info", value: "arrival_info", sortable: true },
				{ title: "Departure Info", value: "departure_info", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
			],

			searchItinerary: "",
			itineraryPerPage: 10,
			itineraries: [],
			itineraryHeaders: [
				{ title: "#", value: "actions", sortable: true },
				{ title: "Day", value: "day_number", sortable: true },
				// { title: "Title", value: "title", sortable: true },
				{ title: "Destination", value: "park", sortable: true },
				{ title: "Activity", value: "activity", sortable: true },
				{ title: "Accomodation", value: "accomodation", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],

			searchInclude: "",
			includePerPage: 10,
			includes: [],
			includeHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Include/Exclude", value: "detail", sortable: true },
				{ title: "Type", value: "type", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],

			searchExclude: "",
			excludePerPage: 10,
			excludes: [],
			excludeHeaders: [
				{ title: "#", value: "actions", sortable: true },
				{ title: "Exclude", value: "excludes", sortable: true },
				{ title: "Type", value: "type", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],

			searchFeedback: "",
			feedbackPerPage: 10,
			feedbacks: [],
			feedbackHeaders: [
				{ title: "#", value: "actions", sortable: true },
				{ title: "Tourist", value: "tourist", sortable: true },
				{ title: "Rate", value: "feedback_rate", sortable: true },
				{ title: "Content", value: "content", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],

			searchLog: "",
			logPerPage: 10,
			logs: [],
			logHeaders: [
				// { title: "#", value: "day", sortable: true },
				// { title: "Action", value: "action", sortable: true },
				// { title: "Date", value: "date", sortable: true },
				// { title: "Info", value: "info", sortable: true },
				// { title: "User", value: "user", sortable: true },
				// { title: "actions", value: "actions", sortable: true },
			],

			openPanels: {
				filterTours: [0],
				tourFilters: [0],
				registeredTours: [0],
				tourSummary: [0],
				tourGuests: [0],
				tourAccomodation: [0],
				panelItinerary: [0],
				tourActivities: [0],
				tourPricing: [0],
				optionalCosts: [0],
				tourFlights: [0],
				tourBoats: [0],
				excludeInclude: [0],
				tourFeedback: [0],
				tourLog: [0],
				selectedItinerary: [0],
				itineraryActivity: [0],
				itineraryActivities: [0],
			},
			toolbars: {
				bold: true,
				italic: true,
				header: true,
				underline: true,
				strikethrough: true,
				mark: false,
				superscript: true,
				subscript: true,
				quote: true,
				ol: true,
				ul: true,
				link: true,
				imagelink: false,
				code: false,
				table: false,
				fullscreen: false,
				readmodel: false,
				htmlcode: false,
				help: true,
				/* 1.3.5 */
				undo: false,
				redo: false,
				trash: false,
				save: false,
				/* 1.4.2 */
				navigation: false,
				/* 2.1.8 */
				alignleft: false,
				aligncenter: false,
				alignright: false,
				/* 2.2.1 */
				subfield: false,
				preview: true,
			},
			// editor: ClassicEditor,
			editorData: "<p>Initial content</p>",
			editorConfig: {
				toolbar: ["heading", "|", "bold", "italic", "link", "undo", "redo"],
			},
		};
	},
	methods: {
		sanitizeHtmlList(htmlString) {
			if (!htmlString) return [];

			// 1. Replace </li> and </p> tags with a unique separator (like a pipe)
			// to preserve line breaks before stripping all other tags.
			let formatted = htmlString.replace(/<\/li>|<\/p>|<br\s*\/?>/gi, "|");

			// 2. Remove all remaining HTML tags using a global regex
			let plainText = formatted.replace(/<[^>]*>/g, "");

			// 3. Split by the separator, trim whitespace, and remove empty strings
			return plainText
				.split("|")
				.map((item) => item.trim())
				.filter((item) => item.length > 0);
		},
		async generateItinerary() {
			this.pdfLoading = true;
			try {
				const logo = await this.imageBase64("/images/speke_banner_black.png");
				const scenery = await this.imageBase64("/images/gorilla_family.webp");
				await this.getInfinites("costs");
				await this.getInfinites("options");

				// Pre-sanitize the HTML lists into arrays
				const sanitizedIncludes = {
					included: this.sanitizeHtmlList(this.tourIncludes.include_detail),
					excluded: this.sanitizeHtmlList(this.tourIncludes.exclude_detail),
				};

				const pdfUrl = await this.generateTourItinerary(
					this.itineraryComputed,
					this.breakdownCosts.data, // tour costs
					this.optionCosts.data.filter((item) => item.cost_kind == "Optional"), // tour optional costs
					sanitizedIncludes, // excludes, includes
					logo, // speke logo
					scenery // speke scenary
				);

				this.pdfDocument = pdfUrl;
			} catch (error) {
				console.error("Tour Itinerary Generation Error:", error);
				this.showError("Failed to generate tour itinerary");
			} finally {
				this.pdfLoading = false;
			}
		},
		submitContent() {
			console.log("Content to submit:", this.tourRegister.excludes);
			// Here you would typically send 'this.myRichTextContent' to your backend
		},
		getTourItem(item) {
			return `${item.reference_number} ${item.client}`;
		},
		selectItem(item) {
			console.log(item);
			this.tourItinerary.itinerary_title = this.capitalizeWords(item.title);
			this.tourItinerary.destination = this.capitalizeWords(item.destination);
			this.tourItinerary.additional_information = this.sentenceCase(
				item.description
			);
		},
		mediumSelection() {
			this.tourItinerary.upper_lodge = null;
			this.tourItinerary.high_lodge = null;
			this.tourItinerary.luxury_lodge = null;
		},
		upperSelection() {
			this.tourItinerary.medium_lodge = null;
			this.tourItinerary.high_lodge = null;
			this.tourItinerary.luxury_lodge = null;
		},
		highSelection() {
			this.tourItinerary.medium_lodge = null;
			this.tourItinerary.upper_lodge = null;
			this.tourItinerary.luxury_lodge = null;
		},
		luxurySelection() {
			this.tourItinerary.medium_lodge = null;
			this.tourItinerary.upper_lodge = null;
			this.tourItinerary.high_lodge = null;
		},
		getStatusColor(status) {
			switch (status.toLowerCase()) {
				case "tentative":
					return "#E4A11B";
				case "cancelled":
					return "#DC4C64";
				case "confirmed":
					return "#14A44D";
				default:
					return "gray"; // Default color if status is unknown
			}
		},
		// Recursive method to search through nested fields
		searchItem(item, query) {
			// Check if item is an object and iterate over its keys
			if (typeof item === "object" && item !== null) {
				return Object.keys(item).some((key) => {
					const value = item[key];
					if (typeof value === "object") {
						// If the value is an object, recursively check its properties
						return this.searchItem(value, query);
					} else if (typeof value === "string") {
						// If the value is a string, check for match
						return value.toLowerCase().includes(query);
					}
					return false;
				});
			}
			return false;
		},
		async openModal(modal, mode) {
			// Show loading indicator
			this.loadModalData = true;

			try {
				// Lazy load tour modal data only when needed
				if (modal == "tour" && !this.tourData) {
					this.tourData = true;
					await Promise.all([
						this.getInfinites("agents"),
						this.getInfinites("languages"),
						this.getInfinites("tourists"),
					]);
				}

				// Lazy load itinerary modal data only when needed
				if (modal == "itinerary" && !this.itineraryData) {
					this.itineraryData = true;
					await Promise.all([
						this.getInfinites("boats"),
						this.getInfinites("country"),
						this.getInfinites("districts"),
						this.getInfinites("flights"),
						this.getInfinites("includes"),
						this.getInfinites("items"),
						this.getInfinites("lodge"),
						this.getInfinites("meal"),
						this.getInfinites("parks"),
						this.getInfinites("rooms"),
						this.getInfinites("towns"),
						this.getInfinites("vehicle-types"),
					]);
				}
			} catch (error) {
				console.error("Error loading modal data:", error);
			} finally {
				// Hide loading indicator
				this.loadModalData = false;
			}

			if (modal == "tour") {
				var user_id = sessionStorage.getItem("user_id");
				if (mode == "update") {
					this.tourRegister.updated_by = user_id;
					this.editMode = true;
					this.tourModal = true;
				} else {
					this.tourRegister.created_by = user_id;
					this.editMode = false;
					this.tourModal = true;
					console.log(this.tourModal);
				}
			} else if (modal == "itinerary") {
				if (this.selectedTour == null) {
					this.showMessage("Please select a tour");
				} else {
					this.getInfinites("days");
					this.getInfinites("expected");
					var user_id = sessionStorage.getItem("user_id");
					if (mode == "update") {
						this.tourItinerary.tour_id = this.selectedTour.tour_id;
						this.tourItinerary.updated_by = user_id;
						this.editMode = true;
						this.itineraryModal = true;
					} else {
						this.tourItinerary.tour_id = this.selectedTour.tour_id;
						this.tourItinerary.created_by = user_id;
						this.editMode = false;
						this.itineraryModal = true;
					}
				}
			} else if (modal == "includes") {
				if (this.selectedTour == null) {
					this.showMessage("Please select a tour");
				} else {
					// Reset and initialize the editorReady flag
					this.editorReady = false;

					var user_id = sessionStorage.getItem("user_id");
					if (mode == "update") {
						this.tourIncludes.tour_id = this.selectedTour.tour_id;
						this.tourIncludes.updated_by = user_id;
						this.editMode = true;
						this.includesModal = true;
					} else {
						this.tourIncludes.tour_id = this.selectedTour.tour_id;
						this.tourIncludes.created_by = user_id;
						this.editMode = false;
						this.includesModal = true;
					}

					// Load includes/excludes data after opening modal
					this.$nextTick(() => {
						this.manageIncludes("None", "fetch");
					});
				}
			} else if (modal == "feedback") {
				if (this.selectedTour == null) {
					this.showMessage("Please select a tour");
				} else {
					var user_id = sessionStorage.getItem("user_id");
					if (mode == "update") {
						this.tourFeedback.tour_id = this.selectedTour.tour_id;
						this.tourFeedback.updated_by = user_id;
						this.editMode = true;
						this.feedbackModal = true;
					} else {
						this.tourFeedback.tour_id = this.selectedTour.tour_id;
						this.tourFeedback.created_by = user_id;
						this.editMode = false;
						this.feedbackModal = true;
					}
				}
			} else if (modal == "log") {
				if (mode == "update") {
					this.editMode = true;
					this.logModal = true;
				} else {
					this.editMode = false;
					this.logModal = true;
				}
			} else if (modal == "preview") {
				this.editMode = true;
				this.pdfDocument = "";
				this.previewModal = true;
				await this.generateItinerary();
			}
		},
		closeModal(modal) {
			if (modal == "tour") {
				this.editMode = false;
				this.tourModal = false;
				this.tourRegister.reset();
				this.tourRegister.errors.clear();
			} else if (modal == "includes") {
				this.editMode = false;
				this.includesModal = false;
				this.editorReady = false; // Reset editor ready flag
				this.tourIncludes.reset();
				this.tourIncludes.errors.clear();
			} else if (modal == "itinerary") {
				this.editMode = false;
				this.itineraryModal = false;
				this.tourDays = [];
				this.tourItinerary.reset();
				this.tourItinerary.errors.clear();
			} else if (modal == "feedback") {
				this.editMode = false;
				this.feedbackModal = false;
				this.tourFeedback.reset();
				this.tourFeedback.errors.clear();
			} else if (modal == "log") {
				this.editMode = false;
				this.logModal = false;
			} else if (modal == "preview") {
				this.editMode = false;
				this.pdfDocument = "";
				this.previewModal = false;
			}
		},
		updateScreenWidth() {
			this.screenWidth = window.innerWidth;
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "options") {
				if (this.selectedTour !== null) {
					api =
						this.api +
						this.prefix +
						"/finance/costs/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						// perform other actions
						this.optionCosts = [];
						this.optionCosts = query.response;
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			} else if (mode == "costs") {
				if (this.selectedTour !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api =
						this.api +
						this.prefix +
						"/finance/costbreak/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.breakdownCosts = [];
						this.breakdownCosts = query.response;
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			} else if (mode == "agents") {
				api = this.api + this.prefix + "/masters/agents";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteAgents = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "country") {
				api = this.api + this.prefix + "/settings/country";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteCountries = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "lodge") {
				api = this.api + this.prefix + "/masters/lodge";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteAccomodations = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "meal") {
				api = this.api + this.prefix + "/masters/meal";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteMeals = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "activity") {
				api = this.api + this.prefix + "/masters/activitiez";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteActivity = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "items") {
				api = this.api + this.prefix + "/masters/items";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteItems = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "days") {
				api =
					this.api +
					this.prefix +
					"/reservation/tour/" +
					this.selectedTour.tour_id +
					"/days";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.tourDays = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "expected") {
				api =
					this.api +
					this.prefix +
					"/reservation/itinerary/" +
					this.selectedTour.tour_id +
					"/expected";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.expectedItinerary = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "itineraryz") {
				api = this.api + this.prefix + "/masters/itineraryz";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteItineraryz = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "tourists") {
				// api = this.api + this.prefix + "/masters/tourist";
				api =
					this.api +
					this.prefix +
					"/reservation/guest/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTourists = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "includes") {
				api = this.api + this.prefix + "/masters/includelist";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteIncludes = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "languages") {
				api = this.api + this.prefix + "/masters/languages";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.guideLanguages = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "boats") {
				api = this.api + this.prefix + "/masters/boats";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteBoats = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "parks") {
				api = this.api + this.prefix + "/masters/parks";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteParks = [];
					this.infiniteParks = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "flights") {
				api = this.api + this.prefix + "/masters/flights";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteFlights = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "vehicles") {
				api = this.api + this.prefix + "/masters/vehicles";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteVehicles = [];
					this.infiniteVehicles = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "vehicle-types") {
				api = this.api + this.prefix + "/masters/vehicle-types";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteVehicles = [];
					this.infiniteVehicles = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "districts") {
				api = this.api + this.prefix + "/masters/districts";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteDistricts = [];
					this.infiniteDistricts = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "towns") {
				api = this.api + this.prefix + "/masters/towns";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTowns = [];
					this.infiniteTowns = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "rooms") {
				api = this.api + this.prefix + "/settings/rooms";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteRooms = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			}
		},
		async manageTours(event, mode) {
			var query, api, selected;
			if (mode == "fetch") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.tours = [];
					this.tours = query.response;
					if (this.selectedTour && this.tours.data) {
						// Find the fresh tour data from the newly loaded tours
						const freshTour = this.tours.data.find(
							(tour) => tour.tour_id === this.selectedTour.tour_id
						);
						if (freshTour) {
							this.selectTour(freshTour);
						} else {
							// Tour no longer exists
							this.selectedTour = null;
							sessionStorage.removeItem("selected_tour");
							this.showMessage("No Tour Selected");
						}
					} else {
						this.showMessage("No Tour Selected");
					}
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.postData(api, this.tourRegister);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					await this.showMessage(this.message);
					this.closeModal("tour");
					this.manageTours("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/reservation/tours/" + event.tour_id;
				query = await this.putData(api, this.tourRegister);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("tour");
					this.manageTours("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "includes") {
				var markdown, html;
				this.tourRegister.reset();
				this.tourRegister.fill(this.selectedTour);
				markdown = new MarkdownIt();
				this.tourRegister.includes = markdown.render(
					this.tourIncludes.includes
				);
				this.tourRegister.excludes = markdown.render(
					this.tourIncludes.excludes
				);
				// console.log("Rendered HTML:", this.tourRegister.includes);

				api = this.api + this.prefix + "/reservation/tours/" + event.id;
				query = await this.putData(api, this.tourRegister);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.manageTours("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourRegister.reset();
				// console.log(event);
				this.tourRegister.fill(event);
				this.tourRegister.agent_id = event.agent;
				this.openModal("tour", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this tour?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/reservation/tours/" + event.tour_id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("tour");
						this.manageTours("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
		async selectTour(event) {
			// Reset editor state when selecting a new tour
			this.editorReady = false;

			sessionStorage.removeItem("selected_tour");
			sessionStorage.setItem("selected_tour", JSON.stringify(event));
			this.selectedTour = event;
			this.showMessage("Tour " + event.reference_number + " selected!");
			this.optionCosts = [];
			this.breakdownCosts = [];
			await this.manageItinerary("None", "fetch");
			await this.manageIncludes("None", "fetch");
			await this.manageFeedback("None", "fetch");
		},
		selectItinerary(event) {
			this.selectedItinerary = null;
			sessionStorage.removeItem("selected_itinerary");
			sessionStorage.setItem("selected_itinerary", JSON.stringify(event));
			this.selectedItinerary = event;
			this.openModal("activity", "insert");
			this.manageActivity("None", "fetch");
		},
		// Custom filter to include hidden fields
		customTourFilter(value, searchTours, item) {
			if (!searchTours) return true;

			search = searchTours.toLowerCase();

			return Object.keys(item).some((key) => {
				const column = this.toursHeaders.find((header) => header.value === key);
				if (!column) return false; // Ignore unknown columns
				return String(item[key]).toLowerCase().includes(search);
			});
		},
		async manageItinerary(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api =
						this.api +
						this.prefix +
						"/reservation/itineraries/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = this.capitalizeWords(query.response.message);
					this.http_code = query.code;
					this.itineraries = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.itineraries = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/reservation/itineraries";
				query = await this.postData(api, this.tourItinerary);
				this.message = this.capitalizeWords(query.response.message);
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("itinerary");
					this.manageItinerary("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api =
					this.api +
					this.prefix +
					"/reservation/itineraries/" +
					event.itinerary;
				query = await this.putData(api, this.tourItinerary);
				this.message = this.capitalizeWords(query.response.message);
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("itinerary");
					this.manageItinerary("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				// Load tour days first if not already loaded
				if (!this.tourDays.data || this.tourDays.data.length === 0) {
					await this.getInfinites("days");
				}

				this.tourItinerary.reset();
				console.log(event);
				this.tourItinerary.fill(event);
				this.tourItinerary.accommodation_id = event.lodge;
				this.tourItinerary.boat_id = event.boat;
				this.tourItinerary.district_id = event.district;
				this.tourItinerary.day_number =
					this.tourDays.data?.find((day) => day.Day === event.day_number) ||
					event.day_number;
				this.tourItinerary.flight_id = event.flight;
				this.tourItinerary.itinerary_item = event.item;
				this.tourItinerary.meal_plan_id = event.tour_lodge?.meal;
				this.tourItinerary.park_id = event.park;
				this.tourItinerary.room_type = event.tour_lodge?.room;
				this.tourItinerary.vehicle_id = event.vehicle;
				// console.log("Setting day_number to:", this.tourItinerary.day_number);
				this.openModal("itinerary", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this itinerary?"
				);
				if (confirmation.result == "Yes") {
					api =
						this.api +
						this.prefix +
						"/reservation/itineraries/" +
						event.itinerary;
					query = await this.deleteData(api);
					this.message = this.capitalizeWords(query.response.message);
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("itinerary");
						this.manageItinerary("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
		async manageIncludes(event, mode) {
			var query, api;
			if (mode == "fetch") {
				let api =
					this.api +
					this.prefix +
					"/reservation/include/" +
					this.selectedTour.tour_id;
				const query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				this.includes = [];
				this.tourIncludes.reset();
				if (query.result == "success" && query.response.data.length > 0) {
					this.includes = query.response;
					// Normalize HTML to remove spaces within tags
					if (this.includes.data[0]) {
						this.tourIncludes.include_detail = this.normalizeHTML(
							this.includes.data[0].include_detail
						);
						this.tourIncludes.exclude_detail = this.normalizeHTML(
							this.includes.data[0].exclude_detail
						);
						this.tourIncludes.id = this.includes.data[0].id;
						this.tourIncludes.tour_id = this.includes.data[0].tour_id;
					}

					// Ensure modal opens after data is filled
					this.$nextTick(() => {
						setTimeout(() => {
							this.editorReady = true;
						}, 500);
					});
				} else {
					// No data found, show empty editors
					this.tourIncludes.include_detail = "No Includes Added";
					this.tourIncludes.exclude_detail = "No Excludes Added";
					this.tourIncludes.tour_id = this.selectedTour.tour_id;
					this.$nextTick(() => {
						this.editorReady = true;
					});
				}
			} else if (mode == "insert") {
				let api = this.api + this.prefix + "/reservation/include";
				const query = await this.postData(api, this.tourIncludes);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("includes");
					this.manageIncludes("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				if (!this.tourIncludes.id) {
					this.manageIncludes(this.tourIncludes, "insert");
					return; // Return early after recursive call
				}

				let api = this.api + this.prefix + "/reservation/include/" + event.id;
				const query = await this.putData(api, this.tourIncludes);

				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("includes");
					this.manageIncludes("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourIncludes.reset();
				console.log(event);
				this.tourIncludes.fill(event);
				this.tourIncludes.tour_id = event.tour;
				this.tourIncludes.include_id = event.include;
				this.openModal("includes", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this Include/Exclude?"
				);
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/reservation/include/" + event.id;
					query = await this.deleteData(api);
					this.message = this.capitalizeWords(query.response.message);
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("includes");
						this.manageIncludes("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
		normalizeHTML(html) {
			// Remove all spaces within/around tags
			if (!html) return html;

			// Step 1: Remove spaces within tags
			html = html.replace(/<\s*\/?\s*([a-zA-Z0-9]+)\s*>/g, (match, tagName) => {
				// Check if it's a closing tag
				if (match.includes("/")) {
					return `</${tagName}>`;
				}
				return `<${tagName}>`;
			});

			// Step 2: Remove spaces between tags
			html = html.replace(/>\s+</g, "><");

			// Step 3: Trim leading/trailing spaces
			return html.trim();
		},
		async manageFeedback(event, mode) {
			var query, api;
			if (mode == "fetch") {
				let api =
					this.api +
					this.prefix +
					"/reservation/feedback/" +
					this.selectedTour.tour_id;
				const query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				this.feedbacks = [];
				if (query.result == "success" && query.response.data.length > 0) {
					this.feedbacks = query.response;
				} else {
					this.showInfo(this.message);
				}
			} else if (mode == "insert") {
				let api = this.api + this.prefix + "/reservation/feedback";
				const query = await this.postData(api, this.tourFeedback);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("feedback");
					this.manageFeedback("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				let api = this.api + this.prefix + "/reservation/feedback/" + event.id;
				const query = await this.putData(api, this.tourFeedback);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("feedback");
					this.manageFeedback("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourFeedback.reset();
				console.log(event);
				this.tourFeedback.fill(event);
				this.tourFeedback.tourist_id = event.tourist;
				this.openModal("feedback", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Feedback?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/reservation/feedback/" + event.id;
					query = await this.deleteData(api);
					this.message = this.capitalizeWords(query.response.message);
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("feedback");
						this.manageIncludes("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
		async manageLog(event, mode) {
			var query, api;
			if (mode == "fetch") {
				let api = this.api + this.prefix + "/reservation/log";
				const query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				let api = this.api + this.prefix + "/reservation/log";
				const query = await this.postData(api, this.tourLog);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				let api = this.api + this.prefix + "/reservation/log/" + event.id;
				const query = await this.putData(api, this.tourLog);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourLog.reset();
				console.log(event);
				this.tourLog.fill(event);
				this.openModal("log", "update");
			} else {
				let api = this.api + this.prefix + "/tourist/" + event.id;
				const query = await this.deleteData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
	},
	watch: {},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/reservations/");
		},
		toursComputed() {
			if (this.tours && this.tours.data) {
				return this.tours.data.map((tour, index) => {
					tour.index = index;
					return tour;
				});
			}
		},
		includesComputed() {
			if (this.includes && this.includes.data) {
				return this.includes.data.map((include, index) => {
					include.index = index;
					return include;
				});
			}
		},
		feedbackComputed() {
			if (this.feedbacks && this.feedbacks.data) {
				return this.feedbacks.data.map((feedback, index) => {
					feedback.index = index;
					return feedback;
				});
			}
		},
		guestsComputed() {
			if (this.guests && this.guests.data) {
				return this.guests.data.map((guest, index) => {
					guest.index = index;
					return guest;
				});
			}
		},
		itineraryComputed() {
			if (this.itineraries && this.itineraries.data) {
				return this.itineraries.data.map((itinerary, index) => {
					itinerary.index = index;
					return itinerary;
				});
			}
		},
		accomodationComputed() {
			if (this.accomodations && this.accomodations.data) {
				return this.accomodations.data.map((accomodation, index) => {
					accomodation.index = index;
					return accomodation;
				});
			}
		},
		activityComputed() {
			if (this.activities && this.activities.data) {
				return this.activities.data.map((activity, index) => {
					activity.index = index;
					return activity;
				});
			}
		},
		filteredTowns() {
			if (!this.infiniteTowns || !this.infiniteTowns.data) {
				return [];
			}

			// If no district is selected, return all towns
			if (!this.tourItinerary.district_id) {
				return this.infiniteTowns.data;
			}

			// Filter towns based on the selected district's district_code
			return this.infiniteTowns.data.filter(
				(town) =>
					town.district_code == this.tourItinerary.district_id.district_code
			);
		},
	},
	created() {
		if (this.selectedTour == null) {
			if (sessionStorage.getItem("selected_tour") !== "") {
				let selected = JSON.parse(sessionStorage.getItem("selected_tour"));
				this.selectedTour = selected;
			}
		}

		// this.getInfinites("agents");
		// this.getInfinites("boats");
		// this.getInfinites("country");
		// this.getInfinites("districts");
		// this.getInfinites("flights");
		// this.getInfinites("includes");
		// this.getInfinites("items");
		// this.getInfinites("languages");
		// this.getInfinites("lodge");
		// this.getInfinites("meal");
		// this.getInfinites("parks");
		// this.getInfinites("tourists");
		// this.getInfinites("towns");
		// this.getInfinites("vehicles");

		this.manageTours("None", "fetch");
		// this.manageItinerary("None", "fetch");
	},
	beforeMount() {},
	mounted() {
		// window.addEventListener("resize", this.updateScreenWidth);
	},
	unmounted() {},
	beforeUnmount() {
		// window.removeEventListener("resize", this.updateScreenWidth);
	},
};
</script>




